import { fireEvent } from '../index';
import Modules from '../modules';
import { NOTIFICATIONS_EVENTS as EVENTS } from './events';

type NotificationTypes = {
  id: number;
  totalRecord: number;
  completelyImported: number;
  partiallyImported: number;
  rejectedCount: number;
  errorCsvLink: string | null;
  createdDate: string;
  uploadedBy: string;
  fileName: string;
  isProcessComplete: boolean;
  status: string;
  size: number;
  updateDate: string;
};

export const trackLast3Notifications = (notifications: NotificationTypes[], clientName: string) => {
  if (notifications?.length > 3) {
    notifications = notifications.slice(0, 3);
  }
  const latest3 = notifications.map(({ id, fileName, uploadedBy }) => ({
    id,
    fileName,
    uploadedBy,
  }));
  fireEvent(EVENTS.MAIN, { latest3, tenant_name: clientName, moduleName: Modules.Session });
};
